
import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}
 
const claimEntityTask = (taskInstanceId: string) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.claimEntityTask)+taskInstanceId+'/complete',
    method: 'POST',
    cache: false,
    body: { },
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { claimEntityTask }
